<button
  #buttonElement
  class="ui-button"
  [ngClass]="[type, disabled ? 'disabled' : '']"
  nz-button
  [nzType]="'primary'"
  [nzGhost]="type === 'secondary'"
  [nzBlock]="block"
  [nzLoading]="loading"
  [disabled]="disabled"
>
  <ng-content></ng-content>
</button>
